import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Flex, CheckboxStateless } from '../../../components';
import { BlockContent } from '../../../components/BlockContent';

export interface CookiesTypeBlockProps {
  content?: CORE_JSON;
  nameMessageId: string;
  nameDefaultMessage: string;
  checkboxDisabled?: boolean;
  checked?: boolean;
  onChangeChecked?: () => void;
}

export const CookiesTypeBlock: FC<CookiesTypeBlockProps> = props => {
  const {
    content,
    nameMessageId,
    nameDefaultMessage,
    checkboxDisabled,
    checked,
    onChangeChecked
  } = props;
  if (!content) return null;

  return (
    <Flex flexDirection="column">
      <Flex mb={2} alignItems="center">
        <CheckboxStateless
          checked={checked}
          disabled={checkboxDisabled}
          onChange={onChangeChecked}
          label={
            <FormattedMessage
              id={nameMessageId}
              defaultMessage={nameDefaultMessage}
            />
          }
        />
      </Flex>
      {Boolean(content?.length) && <BlockContent blocks={content} />}
    </Flex>
  );
};
